import script from "./WarehouseInventoryPickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseInventoryPickerModal.vue?vue&type=script&setup=true&lang=js"

import "./WarehouseInventoryPickerModal.vue?vue&type=style&index=0&id=547d39df&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547d39df"]])

export default __exports__